module.exports = __webpack_public_path__ + "img/interbank.5858fa1.png";